import { render, staticRenderFns } from "./HotelAll.vue?vue&type=template&id=27424ed8&scoped=true"
import script from "./HotelAll.vue?vue&type=script&lang=js"
export * from "./HotelAll.vue?vue&type=script&lang=js"
import style0 from "./HotelAll.vue?vue&type=style&index=0&id=27424ed8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27424ed8",
  null
  
)

export default component.exports